import React from "react";
import { Line } from "react-chartjs-2";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  title: {
    fontSize: "1.5rem",
    fontWeight: "bold",
  },
  record: {
    fontSize: "0.9rem",
    fontWeight: "400",
    marginTop: "10px",
  },
  chartContainer: {
    alignSelf: "center",
    padding: "20px 20px 0px 20px",
    marginBottom: "50px",
    width: "100%",
    maxWidth: "700px",
  },
});

const options = {
  aspectRatio: 16 / 9,
  animation: false,
  plugins: {
    legend: {
      display: false,
    },
  },
  elements: {
    line: {
      tension: 0,
    },
    point: {
      pointRadius: 0,
    },
  },
  scales: {
    y: {
      beginAtZero: true,
    },
  },
};

const LineChart = ({ title, data, max }) => {
  const classes = useStyles();

  return (
    <>
      <p className={classes.title}>{title}</p>
      {max && <p className={classes.record}>Máximo: {max}</p>}
      <div className={classes.chartContainer}>
        <Line data={data} options={options} />
      </div>
    </>
  );
};

export default LineChart;
